import { useEffect, useRef } from "react";
import toast from "react-hot-toast";

interface CheckoutPollingOptions {
  isPro: boolean;
  refetch: () => Promise<void>;
}

export function useCheckoutPolling({ isPro, refetch }: CheckoutPollingOptions) {
  // Refs let the interval callback read current values without a stale closure.
  const isProRef = useRef(isPro);
  const refetchRef = useRef(refetch);
  isProRef.current = isPro;
  refetchRef.current = refetch;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("checkout") !== "success") return;

    const url = new URL(window.location.href);
    url.searchParams.delete("checkout");
    window.history.replaceState({}, "", url.pathname + url.search);

    toast.success("Your plan is active.");

    let attempts = 0;
    const maxAttempts = 15;
    const pollInterval = setInterval(async () => {
      attempts++;
      await refetchRef.current();
      if (isProRef.current || attempts >= maxAttempts) {
        clearInterval(pollInterval);
      }
    }, 2000);

    return () => clearInterval(pollInterval);
  }, []);
}
